import React, { useMemo } from 'react';
import { SelectFieldTW } from '../../../tailwindComponents/selectTW/SelectFieldTW';
import { Tooltip } from '../../../ui-toolkit';
import { DescriptiveSelectOption, SelectTWProps } from '../../../tailwindComponents/selectTW/interfaces';
import {
  defaultNormalizedMaritalStatusData,
  useListMaritalStatusesQuery,
} from '../../../API/order/parties/partyStaticDataApi';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

interface MaritalStatusCreatableProps extends Omit<SelectTWProps, 'options'> {
  name: string;
}

export const MaritalStatusCreatable: React.FC<MaritalStatusCreatableProps> = ({ ...props }) => {
  const { options } = useMemoizedMaritalStatusOptions();
  return (
    <SelectFieldTW
      {...props}
      options={options}
      isCreatable
      formatOptionLabel={(option: DescriptiveSelectOption) => {
        return (
          <div className={'flex flex-row items-center justify-between gap-2'}>
            {option.label}
            <Tooltip tooltipContent={option.description ?? option.label} trigger={'hover'} placement={'right'}>
              <InformationCircleIcon className={'h-6 w-6'} />
            </Tooltip>
          </div>
        );
      }}
    />
  );
};

const useMemoizedMaritalStatusOptions = (): {
  options: DescriptiveSelectOption[];
} => {
  const { data: { maritalStatuses } = defaultNormalizedMaritalStatusData } = useListMaritalStatusesQuery();
  return useMemo(
    () => ({
      options: maritalStatuses.map(({ label, description }) => ({ value: label, label, description })),
    }),
    [maritalStatuses]
  );
};
